export const cfg = {
  nombreApp: "Sofias Ciudadano",
  apiCliente: "web_ciudadano",
  baseUrl: "/",
  prefijoLocalStorage: "sofias.apr.",
  
  
  versionWeb: "66",

  // NO TOCAR, variable inicializada que se especifica su valor a través del servicio "getVersionApi".
  versionAPI: "",

  // Ruta local y ruta de despliegue.
  //apiUrl: "http://localhost:8080/api/v1",
  apiUrl: '/api/v1', //relativa, ACORDARSE de dejar esta para compilar para PRO
  //apiUrl: "https://pre4.ciudadanos.sofias.pro/api/v1"
  //apiUrl: "https://autorizacions.zbevigo.com/api/v1",
  //apiUrl: "https://zbe.aytoboadilla.org/api/v1"

};

